import { FieldDescription, FieldLabel, FieldLabelHint, FieldRoot, FieldValidation } from "../components/field.js";
import { InputBase } from "../components/input-base.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/smart-components/input.tsx
/**
* A text input with a label, optional description, and error/success states.
* Composes ui2 field primitives so it matches the rest of the form-input family.
*/
const Input = ({ className, description, disabled = false, errors, id, label, readOnly = false, required = false, success, tooltipText, wrapperClassName, ref, ...inputProps }) => {
	const hasErrors = Array.isArray(errors) ? errors.length > 0 : Boolean(errors);
	const hasSuccess = Array.isArray(success) ? success.length > 0 : Boolean(success);
	return /* @__PURE__ */ jsxs(FieldRoot, {
		id,
		disabled,
		required,
		invalid: hasErrors,
		className: wrapperClassName,
		children: [
			label && /* @__PURE__ */ jsxs(FieldLabel, { children: [label, tooltipText && /* @__PURE__ */ jsx(FieldLabelHint, { children: tooltipText })] }),
			description && /* @__PURE__ */ jsx(FieldDescription, { children: description }),
			/* @__PURE__ */ jsx(InputBase, {
				ref,
				className,
				disabled,
				readOnly,
				...inputProps
			}),
			hasErrors && /* @__PURE__ */ jsx(FieldValidation, {
				variant: "error",
				children: errors
			}),
			!hasErrors && hasSuccess && /* @__PURE__ */ jsx(FieldValidation, {
				variant: "success",
				children: success
			})
		]
	});
};
//#endregion
export { Input };

//# sourceMappingURL=input.js.map